// VITE NEW IMPORT

export const countryOfOrigin = [
  {
    id: "AF",
    name: "Afghanistan",
  },
  {
    id: "AL",
    name: "Albania",
  },
  {
    id: "DZ",
    name: "Algeria",
  },
  {
    id: "AS",
    name: "American Samoa",
  },
  {
    id: "AD",
    name: "Andorra",
  },
  {
    id: "AO",
    name: "Angola",
  },
  {
    id: "AI",
    name: "Anguilla",
  },
  {
    id: "AQ",
    name: "Antarctica",
  },
  {
    id: "AG",
    name: "Antigua and Barbuda",
  },
  {
    id: "AR",
    name: "Argentina",
  },
  {
    id: "AM",
    name: "Armenia",
  },
  {
    id: "AW",
    name: "Aruba",
  },
  {
    id: "AU",
    name: "Australia",
  },
  {
    id: "AT",
    name: "Austria",
  },
  {
    id: "AZ",
    name: "Azerbaijan",
  },
  {
    id: "BS",
    name: "Bahamas",
  },
  {
    id: "BH",
    name: "Bahrain",
  },
  {
    id: "BD",
    name: "Bangladesh",
  },
  {
    id: "BB",
    name: "Barbados",
  },
  {
    id: "BY",
    name: "Belarus",
  },
  {
    id: "BE",
    name: "Belgium",
  },
  {
    id: "BZ",
    name: "Belize",
  },
  {
    id: "BJ",
    name: "Benin",
  },
  {
    id: "BM",
    name: "Bermuda",
  },
  {
    id: "BT",
    name: "Bhutan",
  },
  {
    id: "BO",
    name: "Bolivia",
  },
  {
    id: "BA",
    name: "Bosnia and Herzegovina",
  },
  {
    id: "BW",
    name: "Botswana",
  },
  {
    id: "BR",
    name: "Brazil",
  },
  {
    id: "IO",
    name: "British Indian Ocean Territory",
  },
  {
    id: "VG",
    name: "British Virgin Islands",
  },
  {
    id: "BN",
    name: "Brunei",
  },
  {
    id: "BG",
    name: "Bulgaria",
  },
  {
    id: "BF",
    name: "Burkina Faso",
  },
  {
    id: "BI",
    name: "Burundi",
  },
  {
    id: "KH",
    name: "Cambodia",
  },
  {
    id: "CM",
    name: "Cameroon",
  },
  {
    id: "CA",
    name: "Canada",
  },
  {
    id: "CV",
    name: "Cape Verde",
  },
  {
    id: "KY",
    name: "Cayman Islands",
  },
  {
    id: "CF",
    name: "Central African Republic",
  },
  {
    id: "TD",
    name: "Chad",
  },
  {
    id: "CL",
    name: "Chile",
  },
  {
    id: "CN",
    name: "China",
  },
  {
    id: "CX",
    name: "Christmas Island",
  },
  {
    id: "CC",
    name: "Cocos Islands",
  },
  {
    id: "CO",
    name: "Colombia",
  },
  {
    id: "KM",
    name: "Comoros",
  },
  {
    id: "CK",
    name: "Cook Islands",
  },
  {
    id: "CR",
    name: "Costa Rica",
  },
  {
    id: "HR",
    name: "Croatia",
  },
  {
    id: "CU",
    name: "Cuba",
  },
  {
    id: "CW",
    name: "Curacao",
  },
  {
    id: "CY",
    name: "Cyprus",
  },
  {
    id: "CZ",
    name: "Czech Republic",
  },
  {
    id: "CD",
    name: "Democratic Republic of the Congo",
  },
  {
    id: "DK",
    name: "Denmark",
  },
  {
    id: "DJ",
    name: "Djibouti",
  },
  {
    id: "DM",
    name: "Dominica",
  },
  {
    id: "DO",
    name: "Dominican Republic",
  },
  {
    id: "TL",
    name: "East Timor",
  },
  {
    id: "EC",
    name: "Ecuador",
  },
  {
    id: "EG",
    name: "Egypt",
  },
  {
    id: "SV",
    name: "El Salvador",
  },
  {
    id: "GQ",
    name: "Equatorial Guinea",
  },
  {
    id: "ER",
    name: "Eritrea",
  },
  {
    id: "EE",
    name: "Estonia",
  },
  {
    id: "ET",
    name: "Ethiopia",
  },
  {
    id: "FK",
    name: "Falkland Islands",
  },
  {
    id: "FO",
    name: "Faroe Islands",
  },
  {
    id: "FJ",
    name: "Fiji",
  },
  {
    id: "FI",
    name: "Finland",
  },
  {
    id: "FR",
    name: "France",
  },
  {
    id: "PF",
    name: "French Polynesia",
  },
  {
    id: "GA",
    name: "Gabon",
  },
  {
    id: "GM",
    name: "Gambia",
  },
  {
    id: "GE",
    name: "Georgia",
  },
  {
    id: "DE",
    name: "Germany",
  },
  {
    id: "GH",
    name: "Ghana",
  },
  {
    id: "GI",
    name: "Gibraltar",
  },
  {
    id: "GR",
    name: "Greece",
  },
  {
    id: "GL",
    name: "Greenland",
  },
  {
    id: "GD",
    name: "Grenada",
  },
  {
    id: "GU",
    name: "Guam",
  },
  {
    id: "GT",
    name: "Guatemala",
  },
  {
    id: "GG",
    name: "Guernsey",
  },
  {
    id: "GN",
    name: "Guinea",
  },
  {
    id: "GW",
    name: "Guinea-Bissau",
  },
  {
    id: "GY",
    name: "Guyana",
  },
  {
    id: "HT",
    name: "Haiti",
  },
  {
    id: "HN",
    name: "Honduras",
  },
  {
    id: "HK",
    name: "Hong Kong",
  },
  {
    id: "HU",
    name: "Hungary",
  },
  {
    id: "IS",
    name: "Iceland",
  },
  {
    id: "IN",
    name: "India",
  },
  {
    id: "ID",
    name: "Indonesia",
  },
  {
    id: "IR",
    name: "Iran",
  },
  {
    id: "IQ",
    name: "Iraq",
  },
  {
    id: "IE",
    name: "Ireland",
  },
  {
    id: "IM",
    name: "Isle of Man",
  },
  {
    id: "IL",
    name: "Israel",
  },
  {
    id: "IT",
    name: "Italy",
  },
  {
    id: "CI",
    name: "Ivory Coast",
  },
  {
    id: "JM",
    name: "Jamaica",
  },
  {
    id: "JP",
    name: "Japan",
  },
  {
    id: "JE",
    name: "Jersey",
  },
  {
    id: "JO",
    name: "Jordan",
  },
  {
    id: "KZ",
    name: "Kazakhstan",
  },
  {
    id: "KE",
    name: "Kenya",
  },
  {
    id: "KI",
    name: "Kiribati",
  },
  {
    id: "XK",
    name: "Kosovo",
  },
  {
    id: "KW",
    name: "Kuwait",
  },
  {
    id: "KG",
    name: "Kyrgyzstan",
  },
  {
    id: "LA",
    name: "Laos",
  },
  {
    id: "LV",
    name: "Latvia",
  },
  {
    id: "LB",
    name: "Lebanon",
  },
  {
    id: "LS",
    name: "Lesotho",
  },
  {
    id: "LR",
    name: "Liberia",
  },
  {
    id: "LY",
    name: "Libya",
  },
  {
    id: "LI",
    name: "Liechtenstein",
  },
  {
    id: "LT",
    name: "Lithuania",
  },
  {
    id: "LU",
    name: "Luxembourg",
  },
  {
    id: "MO",
    name: "Macau",
  },
  {
    id: "MK",
    name: "Macedonia",
  },
  {
    id: "MG",
    name: "Madagascar",
  },
  {
    id: "MW",
    name: "Malawi",
  },
  {
    id: "MY",
    name: "Malaysia",
  },
  {
    id: "MV",
    name: "Maldives",
  },
  {
    id: "ML",
    name: "Mali",
  },
  {
    id: "MT",
    name: "Malta",
  },
  {
    id: "MH",
    name: "Marshall Islands",
  },
  {
    id: "MR",
    name: "Mauritania",
  },
  {
    id: "MU",
    name: "Mauritius",
  },
  {
    id: "YT",
    name: "Mayotte",
  },
  {
    id: "MX",
    name: "Mexico",
  },
  {
    id: "FM",
    name: "Micronesia",
  },
  {
    id: "MD",
    name: "Moldova",
  },
  {
    id: "MC",
    name: "Monaco",
  },
  {
    id: "MN",
    name: "Mongolia",
  },
  {
    id: "ME",
    name: "Montenegro",
  },
  {
    id: "MS",
    name: "Montserrat",
  },
  {
    id: "MA",
    name: "Morocco",
  },
  {
    id: "MZ",
    name: "Mozambique",
  },
  {
    id: "MM",
    name: "Myanmar",
  },
  {
    id: "NA",
    name: "Namibia",
  },
  {
    id: "NR",
    name: "Nauru",
  },
  {
    id: "NP",
    name: "Nepal",
  },
  {
    id: "NL",
    name: "Netherlands",
  },
  {
    id: "AN",
    name: "Netherlands Antilles",
  },
  {
    id: "NC",
    name: "New Caledonia",
  },
  {
    id: "NZ",
    name: "New Zealand",
  },
  {
    id: "NI",
    name: "Nicaragua",
  },
  {
    id: "NE",
    name: "Niger",
  },
  {
    id: "NG",
    name: "Nigeria",
  },
  {
    id: "NU",
    name: "Niue",
  },
  {
    id: "KP",
    name: "North Korea",
  },
  {
    id: "MP",
    name: "Northern Mariana Islands",
  },
  {
    id: "NO",
    name: "Norway",
  },
  {
    id: "OM",
    name: "Oman",
  },
  {
    id: "PK",
    name: "Pakistan",
  },
  {
    id: "PW",
    name: "Palau",
  },
  {
    id: "PS",
    name: "Palestine",
  },
  {
    id: "PA",
    name: "Panama",
  },
  {
    id: "PG",
    name: "Papua New Guinea",
  },
  {
    id: "PY",
    name: "Paraguay",
  },
  {
    id: "PE",
    name: "Peru",
  },
  {
    id: "PH",
    name: "Philippines",
  },
  {
    id: "PN",
    name: "Pitcairn",
  },
  {
    id: "PL",
    name: "Poland",
  },
  {
    id: "PT",
    name: "Portugal",
  },
  {
    id: "PR",
    name: "Puerto Rico",
  },
  {
    id: "QA",
    name: "Qatar",
  },
  {
    id: "CG",
    name: "Republic of the Congo",
  },
  {
    id: "RE",
    name: "Reunion",
  },
  {
    id: "RO",
    name: "Romania",
  },
  {
    id: "RU",
    name: "Russia",
  },
  {
    id: "RW",
    name: "Rwanda",
  },
  {
    id: "BL",
    name: "Saint Barthelemy",
  },
  {
    id: "SH",
    name: "Saint Helena",
  },
  {
    id: "KN",
    name: "Saint Kitts and Nevis",
  },
  {
    id: "LC",
    name: "Saint Lucia",
  },
  {
    id: "MF",
    name: "Saint Martin",
  },
  {
    id: "PM",
    name: "Saint Pierre and Miquelon",
  },
  {
    id: "VC",
    name: "Saint Vincent and the Grenadines",
  },
  {
    id: "WS",
    name: "Samoa",
  },
  {
    id: "SM",
    name: "San Marino",
  },
  {
    id: "ST",
    name: "Sao Tome and Principe",
  },
  {
    id: "SA",
    name: "Saudi Arabia",
  },
  {
    id: "SN",
    name: "Senegal",
  },
  {
    id: "RS",
    name: "Serbia",
  },
  {
    id: "SC",
    name: "Seychelles",
  },
  {
    id: "SL",
    name: "Sierra Leone",
  },
  {
    id: "SG",
    name: "Singapore",
  },
  {
    id: "SX",
    name: "Sint Maarten",
  },
  {
    id: "SK",
    name: "Slovakia",
  },
  {
    id: "SI",
    name: "Slovenia",
  },
  {
    id: "SB",
    name: "Solomon Islands",
  },
  {
    id: "SO",
    name: "Somalia",
  },
  {
    id: "ZA",
    name: "South Africa",
  },
  {
    id: "KR",
    name: "South Korea",
  },
  {
    id: "SS",
    name: "South Sudan",
  },
  {
    id: "ES",
    name: "Spain",
  },
  {
    id: "LK",
    name: "Sri Lanka",
  },
  {
    id: "SD",
    name: "Sudan",
  },
  {
    id: "SR",
    name: "Suriname",
  },
  {
    id: "SJ",
    name: "Svalbard and Jan Mayen",
  },
  {
    id: "SZ",
    name: "Swaziland",
  },
  {
    id: "SE",
    name: "Sweden",
  },
  {
    id: "CH",
    name: "Switzerland",
  },
  {
    id: "SY",
    name: "Syria",
  },
  {
    id: "TW",
    name: "Taiwan",
  },
  {
    id: "TJ",
    name: "Tajikistan",
  },
  {
    id: "TZ",
    name: "Tanzania",
  },
  {
    id: "TH",
    name: "Thailand",
  },
  {
    id: "TG",
    name: "Togo",
  },
  {
    id: "TK",
    name: "Tokelau",
  },
  {
    id: "TO",
    name: "Tonga",
  },
  {
    id: "TT",
    name: "Trinidad and Tobago",
  },
  {
    id: "TN",
    name: "Tunisia",
  },
  {
    id: "TR",
    name: "Turkey",
  },
  {
    id: "TM",
    name: "Turkmenistan",
  },
  {
    id: "TC",
    name: "Turks and Caicos Islands",
  },
  {
    id: "TV",
    name: "Tuvalu",
  },
  {
    id: "VI",
    name: "U.S. Virgin Islands",
  },
  {
    id: "UG",
    name: "Uganda",
  },
  {
    id: "UA",
    name: "Ukraine",
  },
  {
    id: "AE",
    name: "United Arab Emirates",
  },
  {
    id: "GB",
    name: "United Kingdom",
  },
  {
    id: "US",
    name: "United States",
  },
  {
    id: "UY",
    name: "Uruguay",
  },
  {
    id: "UZ",
    name: "Uzbekistan",
  },
  {
    id: "VU",
    name: "Vanuatu",
  },
  {
    id: "VA",
    name: "Vatican",
  },
  {
    id: "VE",
    name: "Venezuela",
  },
  {
    id: "VN",
    name: "Vietnam",
  },
  {
    id: "WF",
    name: "Wallis and Futuna",
  },
  {
    id: "EH",
    name: "Western Sahara",
  },
  {
    id: "YE",
    name: "Yemen",
  },
  {
    id: "ZM",
    name: "Zambia",
  },
  {
    id: "ZW",
    name: "Zimbabwe",
  },
];

export const CountryCodeMaps = {
  afghanistan: "AF",
  "aland islands, finland": "AX",
  albania: "AL",
  algeria: "DZ",
  "american samoa": "AS",
  andorra: "AD",
  angola: "AO",
  anguilla: "AI",
  "antigua and barbuda": "AG",
  argentina: "AR",
  armenia: "AM",
  aruba: "AW",
  australia: "AU",
  austria: "AT",
  azerbaijan: "AZ",
  bahamas: "BS",
  bahrain: "BH",
  bangladesh: "BD",
  barbados: "BB",
  belarus: "BY",
  belgium: "BE",
  belize: "BZ",
  benin: "BJ",
  bermuda: "BM",
  bhutan: "BT",
  bolivia: "BO",
  "bosnia and herzegovina": "BA",
  botswana: "BW",
  brazil: "BR",
  "british virgin islands": "VG",
  brunei: "BN",
  bulgaria: "BG",
  "burkina faso": "BF",
  burundi: "BI",
  "cabo verde": "CV",
  cambodia: "KH",
  cameroon: "CM",
  canada: "CA",
  "caribbean netherlands": "nan",
  "cayman islands": "KY",
  "central african republic": "CF",
  chad: "TD",
  "channel islands": "nan",
  chile: "CL",
  china: "CN",
  "christmas island": "CX",
  "cocos islands": "CC",
  colombia: "CO",
  comoros: "KM",
  "cook islands": "CK",
  "costa rica": "CR",
  croatia: "HR",
  cuba: "CU",
  curacao: "CW",
  cyprus: "CY",
  "czech republic": "CZ",
  "democratic republic of the congo": "CD",
  denmark: "DK",
  djibouti: "DJ",
  dominica: "DM",
  "dominican republic": "DO",
  "east timor": "TL",
  ecuador: "EC",
  egypt: "EG",
  "el salvador": "SV",
  "equatorial guinea": "GQ",
  eritrea: "ER",
  estonia: "EE",
  eswatini: "SZ",
  ethiopia: "ET",
  "falkland islands": "FK",
  "faroe islands": "FO",
  fiji: "FJ",
  finland: "FI",
  france: "FR",
  "french guiana, france": "GF",
  "french polynesia": "PF",
  gabon: "GA",
  gambia: "GM",
  georgia: "GE",
  germany: "DE",
  ghana: "GH",
  gibraltar: "GI",
  greece: "GR",
  grenada: "GD",
  "guadeloupe, france": "GP",
  guam: "GU",
  guatemala: "GT",
  guernsey: "GG",
  guinea: "GN",
  "guinea-bissau": "GW",
  guyana: "GY",
  haiti: "HT",
  honduras: "HN",
  "hong kong": "HK",
  hungary: "HU",
  iceland: "IS",
  india: "IN",
  indonesia: "ID",
  iran: "IR",
  iraq: "IQ",
  ireland: "IE",
  "isle of man": "IM",
  israel: "IL",
  italy: "IT",
  "ivory coast": "CI",
  jamaica: "JM",
  japan: "JP",
  jersey: "JE",
  jordan: "JO",
  kazakhstan: "KZ",
  kenya: "KE",
  kiribati: "KI",
  kosovo: "XK",
  kuwait: "KW",
  kyrgyzstan: "KG",
  laos: "LA",
  latvia: "LV",
  lebanon: "LB",
  lesotho: "LS",
  liberia: "LR",
  libya: "LY",
  liechtenstein: "LI",
  lithuania: "LT",
  luxembourg: "LU",
  macau: "MO",
  madagascar: "MG",
  malawi: "MW",
  malaysia: "MY",
  maldives: "MV",
  mali: "ML",
  malta: "MT",
  "marshall islands": "MH",
  "martinique, france": "MQ",
  mauritania: "MR",
  mauritius: "MU",
  mayotte: "YT",
  mexico: "MX",
  micronesia: "FM",
  moldova: "MD",
  monaco: "MC",
  mongolia: "MN",
  montenegro: "ME",
  montserrat: "MS",
  morocco: "MA",
  mozambique: "MZ",
  myanmar: "MM",
  namibia: "NA",
  nauru: "NR",
  nepal: "NP",
  netherlands: "NL",
  "netherlands antilles": "AN",
  "new caledonia": "NC",
  "new zealand": "NZ",
  nicaragua: "NI",
  niger: "NE",
  nigeria: "NG",
  niue: "NU",
  "norfolk island, australia": "NF",
  "north korea": "KP",
  "north macedonia": "MK",
  "northern mariana islands": "MP",
  norway: "NO",
  oman: "OM",
  pakistan: "PK",
  palau: "PW",
  palestine: "PS",
  panama: "PA",
  "papua new guinea": "PG",
  paraguay: "PY",
  peru: "PE",
  philippines: "PH",
  "pitcairn islands": "PN",
  poland: "PL",
  portugal: "PT",
  "puerto rico": "PR",
  qatar: "QA",
  "republic of the congo": "CG",
  "reunion, france": "RE",
  romania: "RO",
  russia: "RU",
  rwanda: "RW",
  "saint barthelemy": "BL",
  "saint helena": "SH",
  "saint kitts and nevis": "KN",
  "saint lucia": "LC",
  "saint martin": "MF",
  "saint pierre and miquelon": "PM",
  "saint vincent and the grenadines": "VC",
  samoa: "WS",
  "san marino": "SM",
  "sao tome and principe": "ST",
  "saudi arabia": "SA",
  senegal: "SN",
  serbia: "RS",
  seychelles: "SC",
  "sierra leone": "SL",
  singapore: "SG",
  "sint maarten": "SX",
  slovakia: "SK",
  slovenia: "SI",
  "solomon islands": "SB",
  somalia: "SO",
  "south africa": "ZA",
  "south georgia and the south sandwich islands": "GS",
  "south korea": "KR",
  "south sudan": "SS",
  spain: "ES",
  "sri lanka": "LK",
  sudan: "SD",
  suriname: "SR",
  "svalbard and jan mayen": "SJ",
  sweden: "SE",
  switzerland: "CH",
  syria: "SY",
  taiwan: "TW",
  tajikistan: "TJ",
  tanzania: "TZ",
  thailand: "TH",
  "tierra del fuego": "nan",
  togo: "TG",
  tokelau: "TK",
  tonga: "TO",
  "trinidad and tobago": "TT",
  tunisia: "TN",
  turkey: "TR",
  turkmenistan: "TM",
  "turks and caicos islands": "TC",
  tuvalu: "TV",
  "u.s. virgin islands": "VI",
  uganda: "UG",
  ukraine: "UA",
  "united arab emirates": "AE",
  "united kingdom": "GB",
  "united states": "US",
  uruguay: "UY",
  uzbekistan: "UZ",
  vanuatu: "VU",
  "vatican city": "VA",
  venezuela: "VE",
  vietnam: "VN",
  "wallis and futuna": "WF",
  yemen: "YE",
  zambia: "ZM",
  zimbabwe: "ZW",
  us: "US",
};
